module.exports = __webpack_public_path__ + "img/x4.d8f365e4.jpg";